var React = require('react');

function QG1i (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#A1A1A1","d":"M160 145.433c22.091 0 40 17.909 40 40h40c0-44.183-35.818-80-80-80-44.183 0-80 35.817-80 80h40c0-22.092 17.909-40 40-40z","key":0}),React.createElement("path",{"fill":"#EAC762","d":"M40 185.433H0c0 44.183 35.817 80 80 80v-40c-22.091 0-40-17.909-40-40z","key":1}),React.createElement("path",{"fill":"#C49675","d":"M200 185.433h40v80h-40z","key":2}),React.createElement("g",{"key":3},[React.createElement("path",{"fill":"#C49675","d":"M160 80.567c22.091 0 40-17.909 40-40h-80c0 22.092 17.909 40 40 40z","key":0}),React.createElement("path",{"fill":"#3B588C","d":"M160 .567c-22.091 0-40 17.909-40 40h80c0-22.091-17.909-40-40-40z","key":1})])]);
}

QG1i.defaultProps = {"viewBox":"0 0 240 266"};

module.exports = QG1i;

QG1i.default = QG1i;
